const ErrorPage = () => {
    return <div style={{ display: 'flex', justifyContent: 'center' }}>
        <h3>No page can be found.</h3>
    </div>
};

export default ErrorPage;